import React from "react"
import homestyles from "./styles/homestyles.module.css"
import WhyChooseAdaya from "./containers/chooseAdaya/ChooseAdaya"
import OurTeam from "./containers/ourTeam/OurTeam"
import NavBar from "./containers/navBar/NavBar"
import Homebanner from "./components/Homebanner/Homebanner";
import Onestop from "./components/Onestop/Onestop";
import Ourstory from "./components/Ourstory/Ourstory";
import Howhelp from "./components/How-we-help/Howhelp";
import Bottom from "./components/Footerdesign/Bottom";
import Faq from "./components/FAQ/Faq";
import AdayaWorks from "./containers/HowAdayaWorks/Works"
import {  Switch, Route } from "react-router-dom";


function Home() {
  
  return (
    <div className={homestyles.main}>
        <NavBar />
        <Homebanner />
        <Onestop/>
        <AdayaWorks />
        <Ourstory />
        <Howhelp/>
        <WhyChooseAdaya />
        <OurTeam />
        <Faq/>
        <Bottom/>
    </div>
  );
}

export default function Routes () {
  return(
    <>
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/ourstory"  component={Ourstory} />
      <Route path="/whyus"  component={WhyChooseAdaya} />
      <Route path="/contacts"  component={Bottom} />
      <Route path="/ourteam"  component={OurTeam} />
      <Route path="/faq"  component={Faq} />
    </Switch>
    </>
  )
}